import { NO_UPDATE_MSG } from '../stubs';

export default function getActionTooltipMessage(canUpdate) {
  return {
    edit: canUpdate ? '' : NO_UPDATE_MSG,
    delete: canUpdate ? '' : NO_UPDATE_MSG
  };
}
